module.exports = require('../build/addons/MomentLocaleUtils');



//////////////////
// WEBPACK FOOTER
// /Users/kestutis/Projects/fifth-avenue/wp-content/themes/5th/node_modules/react-day-picker/moment/index.js
// module id = 287
// module chunks = 0